<div [formGroup]="form">
  <div class="frame-parent">
    <div class="title-parent">
      <div class="title">
        <div class="title1">
          {{ 'pickup-dropoff-title' | translate }}
        </div>
      </div>
      <div class="frame-wrapper">
        <div class="form-fieldsinputswith-label-wrapper">
          <div class="form-fieldsinputswith-label">
            <div class="input-label-wrapper">
              <div class="input-label" *ngIf="pickupAddressIsTheSame">
                {{ 'pickup-dropoff-label' | translate }}
              </div>
              <div class="input-label" *ngIf="!pickupAddressIsTheSame">
                {{ 'pickup-address' | translate }}
              </div>
            </div>
            <div class="form-fieldsinputs">
              <div class="icon-and-text">
                <img
                  class="iconsoutlinelocation-marker"
                  alt=""
                  src="../assets/icons/location-marker.svg"
                />
                <input
                  type="text"
                  #originInput
                  [placeholder]="placeholderInput"
                  class="address-input"
                  formControlName="originAddress"
                  (input)="onOriginInputChange()"
                />
              </div>
            </div>
            <div class="icon-and-help-text">
              <div>
                <div class="lorem-ipsum-dolor">
                  {{ 'pickup-hint' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-fieldsinputswith-label">
        <div>
          <div class="input-label">{{ 'additional-info-label' | translate }}</div>
        </div>
        <div class="form-fieldsinputs1">
          <div class="icon-and-text1">
            <div>
              <input
                type="text"
                #originExtraInfoInput
                [placeholder]="placeholderExtra"
                class="address-input1"
                formControlName="originAddressDetails"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="check-box">
        <label>
          <input
            type="checkbox"
            name="pickup-contact-same-person"
            id="pickup-contact-same-person"
            (click)="togglePickupAddressIsTheSame()"
            [checked]="pickupAddressIsTheSame"
          /><span class="check-box-text"
            >{{ 'same-address-checkbox' | translate }}</span
          ></label
        >
      </div>
      <div *ngIf="!pickupAddressIsTheSame">
        <div class="frame-wrapper">
          <div class="form-fieldsinputswith-label-wrapper">
            <div class="form-fieldsinputswith-label">
              <div class="input-label-wrapper">
                <div class="input-label">{{ 'dropoff-address' | translate }}</div>
              </div>
              <div class="form-fieldsinputs">
                <div class="icon-and-text">
                  <img
                    class="iconsoutlinelocation-marker"
                    alt=""
                    src="../assets/icons/location-marker.svg"
                  />
                  <input
                    type="text"
                    #destinationInput
                    [placeholder]="placeholderInput"
                    class="address-input"
                    formControlName="destinationAddress"
                    (input)="onDestinationInputChange()"
                  />
                </div>
              </div>
              <div class="icon-and-help-text">
                <div>
                  <div class="lorem-ipsum-dolor">
                    {{ 'pickup-hint' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-fieldsinputswith-label">
          <div>
            <div class="input-label">{{ 'additional-info-label' | translate }}</div>
          </div>
          <div class="form-fieldsinputs1">
            <div class="icon-and-text1">
              <div>
                <input
                  type="text"
                  #destinationExtraInfoInput
                  [placeholder]="placeholderExtra"
                  class="address-input1"
                  formControlName="destinationAddressDetails"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-first-information-layer></app-first-information-layer>
    <div class="button-wrapper">
      <ng-content select="[left-button]"></ng-content>

      <button type="button" class="next-button" [disabled]="!isFormValid()" (click)="handleNext()">
        {{ 'next-button' | translate }}
      </button>
    </div>
    <!-- <button (click)="datos()">datos</button> -->
  </div>
</div>
